import React, { useEffect, useState, useRef } from 'react';
import { isValidArray, isValid, isValidNumber, getArrayfromString } from '../../../utils/utilities';
import { Button, List, Row, Col, Slider, message } from 'antd';
import { getTimeStampInReadableFormat, getMinsBetweenTwoTimes, getHoursAndMinsFromMins } from '../../../utils/date.utils';
import { insertScheduleByStops, resetTripCreate, createScheduleByStops } from './../../../actions/trip-create.actions';
import { useHistory } from 'react-router-dom';
import { CloseOutlined } from '@ant-design/icons';
import regenaratePng from './../../../images/regenarate.png';
import { showConfirm } from './../../custom-components/custom-component';
import { useDispatch } from 'react-redux';
import { loadingAction } from '../../../actions/loading-actions';
import { defaultIndexSelector, scheduleSelector } from '../../../selector/trip-create.selector';
import { useSelector } from 'react-redux';
import { selectedCitiesSelector, selectedStopsSelector } from '../../../selector/trip-create.selector';
import { updateTripAction } from '../../../actions/trip-create.actions';
import { insertTripStops } from '../../../actions/trip-create.actions';

const getRoutes = (tripCitiesWithStops) => {
    let routes = [];
    if (isValidArray(tripCitiesWithStops) && tripCitiesWithStops.length > 0) {
        // Find all cities that are origins (isOrigin: true)
        const originCities = tripCitiesWithStops.filter(city => city.isOrigin);
        
        // Find all cities that are destinations (isDestination: true)
        const destinationCities = tripCitiesWithStops.filter(city => city.isDestination);
        // Create routes between any origin city and any destination city
        for (let i = 0; i < originCities.length; i++) {
            const originCity = originCities[i];
            
            for (let j = 0; j < destinationCities.length; j++) {
                const destinationCity = destinationCities[j];
                var duration = getMinsBetweenTwoTimes(originCity.time, destinationCity.time), mins = 0, perdaymin = 1440;
                
                // Calculate day difference properly
                let originDay = originCity.day, destinationDay = destinationCity.day;
                if (originDay != destinationDay) {
                    // Calculate the actual day difference
                    let dayDifference = destinationDay - originDay;
                    mins = dayDifference * perdaymin;
                    duration = duration + mins;
                }

                routes.push({
                    origin: originCity.city_name,
                    destination: destinationCity.city_name,
                    start_time: originCity.time,
                    end_time: destinationCity.time,
                    origin_day: originCity.day,
                    destination_day: destinationCity.day,
                    durationInMins: duration,
                    duration: getHoursAndMinsFromMins(duration)
                });
            }
        }
    }


    return routes;
}

const getDuration = () => {
    if (isValid(global.travelsAppConfig) && isValid(global.travelsAppConfig.MINIMUM_ROUTE_DURATION)) {
        return Number(global.travelsAppConfig.MINIMUM_ROUTE_DURATION);
    }
    return 120;
}

// Convert Redux selectedStops format to FinalSummary format
const convertStopsToFinalSummaryFormat = (selectedStops, selectedCities, schedule) => {
    if (!selectedStops || Object.keys(selectedStops).length === 0) {
        return [];
    }

    return selectedCities.map((city, index) => {
        const cityName = city.city_name;
        const cityStops = selectedStops[cityName];
        
        if (!cityStops || !cityStops.stops || cityStops.stops.length === 0) {
            const result = {
                city_name: cityName,
                time: cityStops && cityStops.city_time ? cityStops.city_time : null,
                day: cityStops && cityStops.city_day !== undefined && cityStops.city_day !== null ? 
                    Number(cityStops.city_day)+1 : 1,
                latitude: city.latitude || 0,
                longitude: city.longitude || 0,
                display_name: cityName,
                isOrigin: city.isOrigin || false,
                isDestination: city.isDestination || false,
                stops: []
            };

            return result;
        }

        // Find the main stop for this city
        const mainStop = cityStops.stops.find(stop => stop.isMainStop) || cityStops.stops[0];
        
        // Prioritize city-level time and day over main stop time and day
        // If city-level time/day is set, use it; otherwise fall back to main stop
        const cityTime = cityStops.city_time || (mainStop ? mainStop.stop_time : null);
        const cityDay = cityStops.city_day !== undefined && cityStops.city_day !== null ? 
            Number(cityStops.city_day) : 
            (mainStop ? Number(mainStop.day) : 0);
        
        const result = {
            city_name: cityName,
            city: cityName,
            time: cityTime,
            // Note:in the db we are storing from 0 but in excel we are importing from 1 
            // since info like that update data will be day+1 and create is used day directly
            day: schedule?.id ? cityDay+1 : cityDay,
            latitude: city.latitude || 0,
            longitude: city.longitude || 0,
            display_name: cityName,
            isOrigin: city.isOrigin || false,
            isDestination: city.isDestination || false,
            stops: cityStops.stops.map((stop, stopIndex) => ({
                // keep a stable id for UI lists if needed
                id: stop.id || (stopIndex + 1),
                schedule_id: schedule?.id || null,
                // Canonical stop identifiers/timing for createScheduleByStops (client+server consistency)
                address_id: stop.id,
                is_main_stop: stop.isMainStop ? 1 : 0,
                timing: stop.stop_time,
                day: stop.day !== undefined && stop.day !== null ? Number(stop.day)+1 : 1,
                is_active: 1,
                trip_close_point: stop.tripClosePoint === 1 ? 1 : 0,
                order_no: stopIndex + 1,
                name: stop.name,
                city_name: cityName,
                landmark: stop.name,
                latitude: stop.latitude || 0,
                longitude: stop.longitude || 0,
                location: stop.name,
                address: stop.name,
                phone_number: stop.phoneNumber || "-",
                landline_number: stop.landlineNumber,
                display_name: stop.name,
            }))
        };

        return result;
    });
};

export const DirectFinalSummary = (props) => {
    const {
        resetAllData,
        tripScheduleId,
        busFormData,
        partnerSelected,
        temporaryFlowState
    } = props;

    const isTemporaryFlow = isValid(temporaryFlowState) && temporaryFlowState.temporaryCityFlow === true;
    const temporaryCityName = isTemporaryFlow ? temporaryFlowState.newCity?.city_name : null;

    const defaultIndex = useSelector(defaultIndexSelector);
    const selectedCities = useSelector(selectedCitiesSelector);
    const selectedStops = useSelector(selectedStopsSelector);
    const schedule = useSelector(scheduleSelector);

    let defaultDuration = getDuration(defaultIndex);
    let minsJson = {
        0: defaultDuration,
        25: defaultDuration + 60,
        50: defaultDuration + 120,
        75: defaultDuration + 180,
        100: defaultDuration + 240
    };

    const marks = {
        0: defaultDuration / 60,
        25: (defaultDuration + 60) / 60,
        50: (defaultDuration + 120) / 60,
        75: (defaultDuration + 180) / 60,
        100: (defaultDuration + 240) / 60
    };

    const [routes, setRoutes] = useState([]);
    const [minimumMinsTocreateRoute, setminimumMinsTocreateRoute] = useState(minsJson[defaultIndex]);
    const [avoidRoutes, setAvoidRoutes] = useState([]);
    const [tripCitiesWithStops, setTripCitiesWithStops] = useState([]);
    // Blocks a second submit: the ref closes the window before React re-renders,
    // the state drives disabled/loading on the button.
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    let history = useHistory();
    const dispatch = useDispatch();

    // Create a mock schedule object for the FinalSummary component
    const mockSchedule = {
        id: tripScheduleId,
        description: selectedCities.map(city => city.city_name).join(' → ')
    };

    useEffect(() => {
        // Convert selectedStops to the format expected by FinalSummary
        const convertedStops = convertStopsToFinalSummaryFormat(selectedStops, selectedCities, schedule);
        setTripCitiesWithStops(convertedStops);
    }, [selectedStops, selectedCities, schedule]);

    useEffect(() => {
        let generatedRoutes = getRoutes(tripCitiesWithStops);
        if (isTemporaryFlow) {
            // Show only routes involving the new city (server enforces this too)
            generatedRoutes = generatedRoutes.filter((route) =>
                route.origin === temporaryCityName || route.destination === temporaryCityName);
        }
        setRoutes(generatedRoutes);
    }, [tripCitiesWithStops, isTemporaryFlow, temporaryCityName]);

    const setLoading = (bool) => {
        dispatch(loadingAction(bool));
    }

    const onSuccess = () => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        setLoading(false);
        resetAllData();
        dispatch(resetTripCreate());
        history.push({
            pathname: 'trip-create/success',
            state: { selectedScheduleId: mockSchedule.id }
        });
    }

    const onFailure = (dbError) => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
        message.error(dbError);
        setLoading(false);
    }

    // Find trip close point stop ID
    const findTripClosePointStopId = () => {
        for (const city of tripCitiesWithStops) {
            for (const stop of city.stops) {
                if (stop.trip_close_point == 1) {
                    return stop.address_id ?? stop.id ?? null;
                }
            }
        }
        return null;
    };

    const tripClosePointStopId = findTripClosePointStopId();

    return (
        <div className='final-summary-root'>
            <div className='final-summary-header'>
                <h3>Trip: </h3>
                <span>{mockSchedule.description}</span>
            </div>
            <Slider
                color="green"
                className='slider-default'
                marks={marks}
                defaultValue={defaultIndex}
                style={{ width: '250px' }}
                step={25}
                tooltipVisible={false}
                trackStyle={{

                }}
                onChange={(value) => {
                    setminimumMinsTocreateRoute(minsJson[value]);
                }}
            />
            <div className='final-summary-sub-header'>
                <h2>Routes</h2>
                <Button
                    icon={<img src={regenaratePng} />}
                    type="text" className='outline-button refresh-button'
                    onClick={() => {
                        setAvoidRoutes([]);
                    }}
                ></Button>
            </div>
            <div>
                <List
                    dataSource={routes}
                    header={null}
                    renderItem={item => {
                        let originDay = (!schedule.id ? item.origin_day + 1 : item.origin_day);
                        let destinationDay = (!schedule.id ? item.destination_day + 1 : item.destination_day);
                        let routeString = `${item.origin}${item.destination}`;
                        if (Number(minimumMinsTocreateRoute) < Number(item.durationInMins) && avoidRoutes.indexOf(routeString) === -1) {
                            return (
                                <div className='route-list-main'>
                                    <div className='route-list-item'>
                                        <div className='routes-list-root'>
                                            <div className='list-item-header'>
                                                <h3 className='marginRight'>{item.origin}</h3>
                                                <h3>{item.destination}</h3>
                                            </div>
                                            <div className='list-item-sub-header'>
                                                <div className='marginRight'>{getTimeStampInReadableFormat(item.start_time)}</div>
                                                <div className='marginRight'>{`${item.duration}`}</div>
                                                <div>{getTimeStampInReadableFormat(item.end_time)}</div>
                                            </div>
                                            <div className='list-item-sub-header'>
                                                <div className='marginRight'>Day {originDay}</div>
                                                <div>Day {destinationDay}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <Button
                                        icon={<CloseOutlined />}
                                        type="text"
                                        className="outline-button remove-button"
                                        onClick={() => {
                                            showConfirm(() => {
                                                avoidRoutes.push(`${item.origin}${item.destination}`);
                                                setAvoidRoutes([...avoidRoutes]);
                                            }, "Remove route", `Are you sure to remove route from ${item.origin} to ${item.destination}`);
                                        }}
                                    ></Button>
                                </div>
                            )
                        } else {
                            return null
                        }
                    }}
                />
            </div>
            <Row className='final-summary-footer' gutter={[16, 16]}>
                <Col>
                    <Button
                        loading={isSubmitting}
                        disabled={isSubmitting}
                        onClick={() => {
                            if (isSubmittingRef.current) {
                                return;
                            }
                            isSubmittingRef.current = true;
                            setIsSubmitting(true);
                            setLoading(true);

                            if (isTemporaryFlow) {
                                // Temporary add-city: write only the new city's routes/stops
                                // and activate them on this trip; schedule template untouched.
                                insertScheduleByStops(tripCitiesWithStops, minimumMinsTocreateRoute, avoidRoutes, schedule, tripClosePointStopId, 'TIME', () => {
                                    isSubmittingRef.current = false;
                                    setIsSubmitting(false);
                                    setLoading(false);
                                    message.success(`Temporary city ${temporaryCityName} added for ${temporaryFlowState.startDate}`);
                                    resetAllData();
                                    dispatch(resetTripCreate());
                                    history.goBack();
                                }, onFailure, {
                                    isTemporary: true,
                                    temporaryCityName: temporaryCityName,
                                    tripId: temporaryFlowState.tripId
                                });
                                return;
                            }

                            // Check if this is a new trip (no schedule.id) or existing trip
                            if (!schedule.id) {
                                // New trip - use createScheduleByStops
                                // Get the bus and fare information from busFormData
                                const busId = busFormData?.bus_id || 1; // Default bus ID
                                const fare = busFormData?.fare || 0; // Default fare
                                
                                // Construct fareJson from individual fare fields
                                let fareJson = '{}';
                                if (busFormData) {
                                    const fareJsonObj = {};
                                    // Add main fare if available
                                    if (busFormData.fare) {
                                        fareJsonObj.fare = busFormData.fare;
                                    }
                                    let seatGroupIds = getArrayfromString(busFormData.seat_group_ids, ',');
                                    // Add seat group fares if available
                                    Object.keys(busFormData).forEach(key => {
                                        if (seatGroupIds.includes(key)) {
                                            fareJsonObj[key] = busFormData[key];
                                        }
                                    });
                                    if (Object.keys(fareJsonObj).length > 0) {
                                        fareJson = JSON.stringify(fareJsonObj);
                                    }
                                }

                                let finalRoutes = [];

                                routes.forEach(route => {
                                    if (Number(minimumMinsTocreateRoute) < Number(route.durationInMins) && avoidRoutes.indexOf(route.origin + route.destination) === -1) {
                                        finalRoutes.push(route);
                                    }
                                });
                                
                                const tripIdentifier = busFormData?.trip_identifier || 'New Trip'; // Default trip name

                                // shift to server-expected 0-based day (kept consistent across client/server)
                                tripCitiesWithStops.forEach(city => {
                                    city.stops.forEach(stop => {
                                        stop.day = stop.day - 1;
                                    });
                                });

                                // Validate required fields before hitting API
                                const invalidStops = [];
                                tripCitiesWithStops.forEach((city) => {
                                    (city.stops || []).forEach((stop) => {
                                        const displayName = stop.display_name || stop.displayName || stop.name || stop.location || 'Unknown stop';
                                        const cityName = city.city_name || city.city || city.display_name || city.displayName || 'Unknown city';

                                        if (!isValid(stop.address_id)) {
                                            invalidStops.push({ city: cityName, stop: displayName, issue: 'Missing stop id (address_id)' });
                                        }
                                        if (!isValid(stop.timing)) {
                                            invalidStops.push({ city: cityName, stop: displayName, issue: 'Missing stop timing' });
                                        }
                                        if (!isValidNumber(stop.day)) {
                                            invalidStops.push({ city: cityName, stop: displayName, issue: 'Missing/invalid stop day' });
                                        }
                                    });
                                });

                                if (invalidStops.length > 0) {
                                    console.error('Invalid stops payload. Blocking createScheduleByStops.', invalidStops, tripCitiesWithStops);
                                    message.error(`Please fix stops before creating trip. Invalid rows: ${invalidStops.length}`);
                                    isSubmittingRef.current = false;
                                    setIsSubmitting(false);
                                    setLoading(false);
                                    return;
                                }
                                
                                dispatch(createScheduleByStops(
                                    tripCitiesWithStops,
                                    finalRoutes,
                                    busId,
                                    fare,
                                    fareJson,
                                    tripIdentifier,
                                    null, // cloneScheduleId is null for new trips
                                    busFormData?.cut_route_enabled ? 1 : 0,
                                    busFormData?.bp_check_enabled ? 1 : 0,
                                    onSuccess,
                                    onFailure
                                ));
                            } else {
                                let tripIdentifier = busFormData.trip_identifier;
                                let fareJSONData = JSON.parse(schedule.fareJson);
                                let lastTripStop = tripCitiesWithStops[tripCitiesWithStops.length-1];
                                schedule.trip_identifier = tripIdentifier;
                                let description = tripCitiesWithStops[0].city_name + " " + lastTripStop.city_name + " " + getTimeStampInReadableFormat(tripCitiesWithStops[0].time) +" " + schedule.busSelected.description + " " + tripIdentifier;
                                let scheduleAgentData = {"start_time": tripCitiesWithStops[0].time, "bus_id": schedule.busId, "fare": schedule.fare, "fare_json": schedule.fareJson,"selectedCities": tripCitiesWithStops,
                                     "blocked_seat_numbers": schedule.blocked_seat_numbers, "trip_identifier": schedule.trip_identifier, "description": description, ...fareJSONData, end_time: lastTripStop.time,
                                    "origin": tripCitiesWithStops[0].city_name, "destination": lastTripStop.city_name, "origin_latitude": tripCitiesWithStops[0].latitude, "origin_longitude": tripCitiesWithStops[0].longitude,
                                    "destination_latitude": lastTripStop.latitude, "destination_longitude": lastTripStop.longitude, "destination_day": lastTripStop.day,
                                    "travels_id": global.travelsId, "operator_name": global.operatorName, "operator_code": global.operatorCode
                                };
                                if(isValidArray(partnerSelected)){
                                    scheduleAgentData['partner_code'] = partnerSelected.partner_code;
                                }

                                let tripStopsData = {};
                                tripCitiesWithStops.forEach(city => {
                                    tripStopsData[city.city_name] = city.stops.map(stop => ({
                                        "address_id":stop.address_id,
                                        "time":stop.timing,
                                        "day":stop.day-1
                                    }));
                                });
                                dispatch(updateTripAction(schedule.id, {...scheduleAgentData}, ()=> {
                                    dispatch(insertTripStops(tripStopsData, schedule.id, ()=> {
                                        insertScheduleByStops(tripCitiesWithStops, minimumMinsTocreateRoute, avoidRoutes, schedule, tripClosePointStopId, 'TIME', onSuccess, onFailure);
                                    }, onFailure));
                                }, onFailure));
                            }
                        }}
                    >
                        Done
                    </Button>
                </Col>
            </Row>
        </div>
    )
} 